module.exports = __webpack_public_path__ + "static/media/3.71362113.ogg";